export default __webpack_public_path__ + "static/media/documents4.a0c9058f.svg";